/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Directory_Ai_Tools_Related_DescriptionInputs */

const en_directory_ai_tools_related_description = /** @type {(inputs: Directory_Ai_Tools_Related_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prefer a different tool? These are the most popular related tools listed on ${i?.app}.`)
};

const zh_directory_ai_tools_related_description = /** @type {(inputs: Directory_Ai_Tools_Related_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`想试试别的工具？这些是 ${i?.app} 上最受欢迎的相关工具。`)
};

/**
* | output |
* | --- |
* | "Prefer a different tool? These are the most popular related tools listed on {app}." |
*
* @param {Directory_Ai_Tools_Related_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_related_description = /** @type {((inputs: Directory_Ai_Tools_Related_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Related_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_related_description(inputs)
	return zh_directory_ai_tools_related_description(inputs)
});
export { directory_ai_tools_related_description as "directory.ai_tools.related_description" }